import { LoansRequest, LoansResponseModel } from '@gtpl/shared-models/gtpl';
import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { LoansDTO } from './dto/loans.dto';
import { LoansService } from './loans.service';
@ApiTags('Loans')
@Controller('Loans')
export class LoansController {
    constructor(
         private loanService: LoansService
    ){}
    @Post('/getLoans')
    async getLoans(@Body() loansRequest: LoansDTO,@Req() request: Request): Promise<LoansResponseModel> {
      console.log(loansRequest);
      try {
        return await this.loanService.getLoans(loansRequest);
      } catch (error) {
        throw new LoansResponseModel(false,11104, 'Something wrong');
      }
    }
}
